import React, { useState } from 'react';
import * as conf from "../../config/config";

const VideoPlayer = ({ 
  videos, 
  dispositivo, 
  alarma, 
  videoRef, 
  playing, 
  setPlaying, 
  volume, 
  setVolume, 
  muted, 
  setMuted, 
  estatusIndex, 
  seguirVideo,
  token 
}) => {
  
  const [isFullscreen, setIsFullscreen] = useState(false);
  
  const handlePlayPause = () => {
    for(let ref of videoRef){
      if (ref && ref.current) {
        setPlaying(ref.current.paused ? true: false);
        ref.current.paused ? ref.current.play() : ref.current.pause();
      }
    }
    seguirVideo();
  };

  const handleVolumeToggle = () => {
    const newMuted = !muted;
    setMuted(newMuted);
    for(let ref of videoRef){
      if (ref && ref.current) {
        ref.current.muted = newMuted;
      }
    }
  };

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    setMuted(newVolume === 0);
    for(let ref of videoRef){
      if (ref && ref.current) {
        ref.current.volume = newVolume;
        ref.current.muted = newVolume === 0;
      }
    }
  };

  const handleProgressClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const percentage = clickX / rect.width;
    const newTime = percentage * (videoRef[0]?.current?.duration || 0);
    
    for(let ref of videoRef){
      if (ref && ref.current) {
        ref.current.currentTime = newTime;
      }
    }
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  const containerStyle = isFullscreen ? {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: '#000',
    zIndex: 9999,
    padding: '20px'
  } :
  {
    backgroundColor: '#000',
  };

  const ControlsComponent = () => (
    <div className='row mt-2'>
      <div className='col-12'>
        <div className="d-flex align-items-center bg-dark rounded p-2" style={{gap: '10px'}}>
          <button 
            className='btn btn-light rounded-circle d-flex align-items-center justify-content-center'
            style={{width: '40px', height: '40px', border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.15)'}}
            onClick={handlePlayPause}
          >
            <i className={`fa fa-${playing? "pause":"play"} text-dark`} style={{fontSize: '14px'}} />
          </button>

          <div className="d-flex align-items-center" style={{gap: '6px'}}>
            <button 
              className='btn btn-outline-light btn-sm rounded-circle d-flex align-items-center justify-content-center'
              style={{width: '30px', height: '30px', border: '1px solid rgba(255,255,255,0.3)'}}
              onClick={handleVolumeToggle}
            >
              <i className={`fa fa-volume-${muted ? 'off' : 'up'} text-light`} style={{fontSize: '12px'}} />
            </button>
            <input 
              type="range" 
              min="0" 
              max="1" 
              step="0.1" 
              value={muted ? 0 : volume}
              style={{
                width: '60px',
                height: '3px',
                background: 'linear-gradient(to right, #007bff 0%, #007bff ' + (muted ? 0 : volume * 100) + '%, rgba(255,255,255,0.3) ' + (muted ? 0 : volume * 100) + '%, rgba(255,255,255,0.3) 100%)',
                borderRadius: '2px',
                outline: 'none',
                cursor: 'pointer'
              }}
              onChange={handleVolumeChange}
            />
          </div>

          <div className="flex-grow-1 mx-2" style={{flexGrow: 1}}>
            <div 
              className="position-relative"
              style={{
                height: '4px', 
                backgroundColor: 'rgba(255,255,255,0.2)', 
                borderRadius: '2px',
                cursor: 'pointer',
                overflow: 'hidden'
              }}
              onClick={handleProgressClick}
            >
              <div 
                style={{
                  width: videoRef[0]?.current?.duration ? 
                    `${(estatusIndex / videoRef[0].current.duration) * 100}%` : '0%',
                  height: '100%',
                  background: 'linear-gradient(90deg, #007bff, #0056b3)',
                  borderRadius: '2px',
                  transition: 'width 0.1s ease',
                  position: 'relative'
                }}
              >
                <div 
                  style={{
                    position: 'absolute',
                    right: '-4px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '8px',
                    height: '8px',
                    backgroundColor: '#007bff',
                    borderRadius: '50%',
                    border: '1px solid white',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                  }}
                />
              </div>
            </div>
          </div>

          <div className="text-light" style={{fontSize: '12px', fontFamily: 'monospace', minWidth: '70px'}}>
            {Math.floor(estatusIndex / 60).toString().padStart(2, '0')}:
            {(estatusIndex % 60).toString().padStart(2, '0')} / 
            {Math.floor((videoRef[0]?.current?.duration || 0) / 60).toString().padStart(2, '0')}:
            {Math.floor((videoRef[0]?.current?.duration || 0) % 60).toString().padStart(2, '0')}
          </div>

          <button 
            className='btn btn-outline-light btn-sm rounded-circle d-flex align-items-center justify-content-center'
            style={{width: '30px', height: '30px', border: '1px solid rgba(255,255,255,0.3)'}}
            onClick={toggleFullscreen}
          >
            <i className={`fa fa-${isFullscreen ? 'compress' : 'expand'} text-light`} style={{fontSize: '12px'}} />
          </button>
        </div>
      </div>
    </div>
  );

  const getVideoSrc = (channel) => {
    return conf.api_raiz + "evidencias/obtener_video_s3/alarma?key="+token+"&id="+alarma.id+"&canal="+channel+"&tipo=video";
  };

  const channels = videos.eid && videos.videoArray ? videos.videoArray.first :
    (Array.isArray(videos) ? videos.filter(v => v.fileType === "VIDEO") : []);

  return (
    <div className='bg-dark' style={containerStyle}>
      {channels.length ?
        <div>
          <div className='row p-2' style={{minHeight: isFullscreen ? '80vh' : '200px'}}>
            {channels.map((e,i)=>{
              const channel = e.channel || i;
              return <div className='col p-1' key={i} onClick={handlePlayPause} style={{overflow: 'hidden'}}>
                <h5 className='text-light mb-2'> Canal {channel}</h5>
                <video 
                  width="100%" 
                  ref={videoRef[i]}
                  src={getVideoSrc(channel)}
                  type="video/mp4"
                  controls={false}
                  style={{
                    maxWidth: '100%',
                    height: isFullscreen ? '70vh' : 'auto',
                    objectFit: 'contain',
                    backgroundColor: '#000'
                  }}>
                  Your browser does not support the video tag.
                </video>
              </div>
            })}
          </div>
          <ControlsComponent />
        </div>
      :
        <div className='row p-2' style={{minHeight: isFullscreen ? '80vh' : '400px'}}></div>
      }
    </div>
  );
};

export default VideoPlayer;
